import { firestorage } from "../../../firebase/firestorage";
import firestore from "../../../firebase/firestore";
// import { getCards } from '../../../services/support/cards'

export default {
  resetFilter({ commit }) {
    commit("resetState");
  },
  async getUtilityFiles({ commit }) {
    // console.log('getUserByParams')
    try {
      // commit('setActiveBilling', 0)
      commit("setLoading", true);
      let FilesList = [];
      // console.log('params: ', params)
      firestore
        .collection("utility_files_management")
        .where("status", "in", ["generated", "sent", "accepted"])
        .orderBy("created_at", "desc")
        .onSnapshot(async (res) => {
          const changes = res.docChanges();
          for (const [, change] of changes.entries()) {
            const { doc } = change;
            switch (change.type) {
              case "added": {
                let new_doc = {
                  id: doc.id,
                  ...doc.data(),
                };
                FilesList.push(new_doc);
                break;
              }
              case "modified": {
                let new_doc = {
                  id: doc.id,
                  ...doc.data(),
                };
                const i = FilesList.findIndex((i) => i.id === doc.id);
                FilesList.splice(i, 1, new_doc);
                break;
              }
              case "removed": {
                FilesList = FilesList.filter((i) => i.id !== doc.id);
                break;
              }
              default:
                break;
            }
          }
          commit("setLoading", false);
          await commit("setFiles", FilesList);
          return FilesList;
        });
    } catch (err) {
      commit("setFiles", []);
      console.error(err);
      commit("setLoading", false);
    }
  },
  async getUtilityFileItems({ commit }, utility_file_id) {
    // console.log('getUserByParams')
    try {
      // commit('setActiveBilling', 0)
      commit("setItemLoading", true);
      let itemsList = [];
      // console.log('params: ', params)
      firestore
        .collection("utility_files_management")
        .doc(utility_file_id)
        .collection("utility_file_items")
        .orderBy("percentage", "desc")
        .onSnapshot(async (res) => {
          const changes = res.docChanges();
          for (const [, change] of changes.entries()) {
            const { doc } = change;
            switch (change.type) {
              case "added": {
                let new_doc = {
                  id: doc.id,
                  ...doc.data(),
                };
                itemsList.push(new_doc);
                break;
              }
              case "modified": {
                let new_doc = {
                  id: doc.id,
                  ...doc.data(),
                };
                const i = itemsList.findIndex((i) => i.id === doc.id);
                itemsList.splice(i, 1, new_doc);
                break;
              }
              case "removed": {
                itemsList = itemsList.filter((i) => i.id !== doc.id);
                break;
              }
              default:
                break;
            }
          }
          commit("setItemLoading", false);
          await commit("setFileItems", itemsList);
          return itemsList;
        });
    } catch (err) {
      commit("setFiles", []);
      console.error(err);
      commit("setItemLoading", false);
    }
  },
  async deleteFileItem({ commit }, { utility_file_id, id }) {
    // console.log('getUserByParams')
    try {
      // commit('setActiveBilling', 0)
      commit("setItemLoading", true);
      // let itemsList = []
      // console.log('params: ', params)
      console.log("utility_file_id: ", utility_file_id);
      console.log("id: ", id);
      await firestore
        .collection("utility_files_management")
        .doc(utility_file_id)
        .collection("utility_file_items")
        .doc(id)
        .update({ status: "removed", updated_at: new Date() })
        .then(() => {
          console.log(
            "Unidade Consumidora (" + id + " removida do arquivo com sucesso",
          );
        })
        .catch((err) => console.error(err));
      commit("setItemLoading", false);
    } catch (err) {
      // commit('setFiles', [])
      console.error(err);
      commit("setItemLoading", false);
    }
  },
  async editFileItem({ commit }, params) {
    // console.log('getUserByParams')
    try {
      // commit('setActiveBilling', 0)
      commit("setItemLoading", true);
      // let itemsList = []
      // console.log('params: ', params)
      // console.log('utility_file_id: ', params.utility_file_id)
      // console.log('params: ', params)
      let data = {
        updated_at: new Date(),
        percentage: params.percentage,
        status: params.status,
      };
      // console.log('data: ', data)

      await firestore
        .collection("utility_files_management")
        .doc(params.utility_file_id)
        .collection("utility_file_items")
        .doc(params.id)
        .update(data)
        .then(() => {
          console.log(
            "Unidade Conumidora (" +
              params.id +
              " atualizada do arquivo com sucesso",
          );
        })
        .catch((err) => console.error(err));
      commit("setItemLoading", false);
    } catch (err) {
      // commit('setFiles', [])
      console.error(err);
      commit("setItemLoading", false);
    }
  },
  async saveSent({ commit }, params) {
    commit("setLoading", true);
    try {
      let data = {
        history: [
          ...params.history,
          {
            event: "sent",
            at: new Date(),
          },
        ],
        last_sent: params.date,
        updated_at: new Date(),
      };
      console.log(data);
      await firestore
        .collection("utility_files_management")
        .doc(params.utility_file_id)
        .update(data)
        .then(() => {
          console.log("Data de envio salvo com sucesso");
        })
        .catch((err) => console.error(err));
    } catch (err) {
      console.error(err);
    }
    commit("setLoading", false);
  },
  async saveExport({ commit }, params) {
    commit("setLoading", true);
    try {
      let csvContent = "";
      params.data.forEach(function (rowArray, index) {
        let row = rowArray.join(",");
        if (index === params.data.length - 1) csvContent += row;
        else csvContent += row + "\r\n";
      });
      const date = new Date().toISOString();
      const cloud_path = `listas_concessionaria/cemig/${
        params.expected_competence
      }_${params.power_plant_id.toUpperCase()}_${date}.csv`;
      const response = await firestorage
        .ref()
        .child(cloud_path)
        .putString(csvContent);
      const file_path = response.metadata.fullPath;
      console.log(file_path);
      let data = {
        history: [
          ...params.history,
          {
            event: "export",
            at: new Date(),
            file_path: file_path,
            done_by: params.done_by || null,
          },
        ],
        last_export_at: new Date(),
        last_export_file: file_path,
        updated_at: new Date(),
      };
      await firestore
        .collection("utility_files_management")
        .doc(params.utility_file_id)
        .update(data)
        .then(() => {
          console.log("Lista exportada e salva com sucesso");
        })
        .catch((err) => console.error(err));
    } catch (err) {
      console.error(err);
    }
    commit("setLoading", false);
  },
};
